import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ScrollToTop } from './components/ScrollToTop';
// Pages
import { Home } from './pages/Home';
import { NonMedicalTransportation } from './pages/NonMedicalTransportation';
import { Services } from './pages/Services';
import { Fleet } from './pages/Fleet';
import { FleetCars } from './pages/FleetCars';
import { FleetVans } from './pages/FleetVans';
import { FleetTrucks } from './pages/FleetTrucks';
import { FleetSUVs } from './pages/FleetSUVs';
import { Booking } from './pages/Booking';
import { Partners } from './pages/Partners';
import { Shipping } from './pages/Shipping';
import { ServiceArea } from './pages/ServiceArea';
import { About } from './pages/About';
import { FAQ } from './pages/FAQ';
import { Contact } from './pages/Contact';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Layout data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/non-medical-transportation" element={<NonMedicalTransportation data-id="element-7" />} data-id="element-6" />
          <Route path="/services" element={<Services data-id="element-9" />} data-id="element-8" />
          <Route path="/fleet" element={<Fleet data-id="element-11" />} data-id="element-10" />
          <Route path="/fleet/cars" element={<FleetCars data-id="element-13" />} data-id="element-12" />
          <Route path="/fleet/vans" element={<FleetVans data-id="element-15" />} data-id="element-14" />
          <Route path="/fleet/trucks" element={<FleetTrucks data-id="element-17" />} data-id="element-16" />
          <Route path="/fleet/suvs" element={<FleetSUVs data-id="element-19" />} data-id="element-18" />
          <Route path="/booking" element={<Booking data-id="element-21" />} data-id="element-20" />
          <Route path="/partners" element={<Partners data-id="element-23" />} data-id="element-22" />
          <Route path="/shipping" element={<Shipping data-id="element-25" />} data-id="element-24" />
          <Route path="/service-area" element={<ServiceArea data-id="element-27" />} data-id="element-26" />
          <Route path="/about" element={<About data-id="element-29" />} data-id="element-28" />
          <Route path="/faq" element={<FAQ data-id="element-31" />} data-id="element-30" />
          <Route path="/contact" element={<Contact data-id="element-33" />} data-id="element-32" />
          <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-35" />} data-id="element-34" />
        </Routes>
      </Layout>
    </Router>;
}